import { render } from "./AboutUsHome.vue?vue&type=template&id=3e4deb68&scoped=true"
import script from "./AboutUsHome.vue?vue&type=script&lang=js"
export * from "./AboutUsHome.vue?vue&type=script&lang=js"

import "./AboutUsHome.vue?vue&type=style&index=0&id=3e4deb68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e4deb68"]])

export default __exports__